<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'payBillAdd',
    components: {
      baseEdit,
    },
  };
</script>
